const SHARE_TYPES = Object.freeze({
  FACEBOOK: "facebook",
  SMS: "sms",
  EMAIL: "email",
  MORE: "more",
});

export { SHARE_TYPES };
